import { disabled } from '../../../new/components/SuperTooltip/components/NavigationButton.css';
import {
  toggleHandle,
  toggleHandleInner,
  toggleRecipe,
  ToggleRecipe,
} from './Toggle.css';

type ToggleProps = {
  value: unknown;
  onChange?: (value: boolean) => any;
  variant?: ToggleRecipe['variant'];
  size?: ToggleRecipe['size'];
  disabled?: boolean;
};

// TODO: hover state
// TODO: disabled state
// todo default size
export const Toggle = ({
  value,
  onChange,
  variant = 'black',
  size = 'medium',
  disabled = false,
}: ToggleProps) => {
  const state = value ? 'active' : 'inactive';
  return (
    <div
      className={toggleRecipe({
        variant,
        size,
        state,
        disabled,
      })}
      onClick={() => !disabled && onChange?.(!value)}
    >
      <div className={toggleHandle({ size, state })}>
        <div className={toggleHandleInner} />
      </div>
    </div>
  );
};
